<template>
  <div class="text-center mysupporters">
    <div class="delegate" v-if="slide[1] && !modal.count">
      <b>1) Cadastro de técnicos</b><br /><br /><img
        src="../../assets/img/mySupporter.png"
      />
    </div>
    <div class="delegate" v-if="slide[2]">
      <b>{{ modal.count ? 1 : 2 }}) Delegação atendimento</b><br /><br />
      <img src="../../assets/img/delegate.png" />
    </div>
    <div class="delegate" v-if="slide[3]">
      <b>{{ modal.count ? 2 : 3 }}) Reassumir atendimento</b><br /><br />
      <img src="../../assets/img/resume.png" />
    </div>
    <ul class="dots row justify-center">
      <li
        v-if="!modal.count"
        :class="slide[1] ? 'active' : ''"
        @click="nextSlide(1)"
      ></li>
      <li :class="slide[2] ? 'active' : ''" @click="nextSlide(2)"></li>
      <li :class="slide[3] ? 'active' : ''" @click="nextSlide(3)"></li>
    </ul>
    <br />
    <Button layout="green-go" @click="nextSlide()" v-if="count < 4"
      >PRÓXIMO</Button
    ><br /><br />
    <br />
    <input type="checkbox" v-model="hide" @click="setHide" /> Não mostrar esta
    caixa novamente <br />
    <br />
    <br />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Button from "@/components/Button.vue";
export default {
  components: { Button },
  props: { modal: Object },
  data() {
    return {
      count: this.modal.count || 2,
      slide: {
        1: this.modal.count ? false : true,
        2: this.modal.count == 2 ? true : false,
        3: false,
      },
      hide: false,
    };
  },
  methods: {
    setHide() {
      localStorage.setItem("equipe", this.hide);
    },
    nextSlide(n) {
      this.slide = {
        1: false,
        2: false,
        3: false,
      };
      if (n) {
        this.slide[n] = true;
        this.count = n + 1;
      } else this.slide[this.count++] = true;
    },
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.mysupporters {
  img {
    width: 95%;
    max-width: 900px;
    border-radius: 23px;
  }
  .delegate {
    text-align: left;
    padding: 28px;
    font-size: 19px;
  }
  .dots {
    padding: 10px;
    li {
      border: 1px solid #ccc;
      border-radius: 50%;
      background: $white-3;
      width: 15px;
      height: 15px;
      box-shadow: $shadow;
      margin: 5px;
      cursor: pointer;
    }
    .active {
      background: $blue-4;
    }
  }
}
</style>